// @ts-nocheck
import { findDOMNode } from 'react-dom';
import React, { useEffect, useRef, useState } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import ReactPlayer from 'react-player';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useStyles from './VideoPlayer-styles';

import Controls from './Controls';
import FullScreen from '@material-ui/icons/Fullscreen';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeMute from '@material-ui/icons/VolumeOff';
import VolumeUp from '@material-ui/icons/VolumeUp';
import screenful from 'screenfull';

// NOTE:
// ./src/modules/Private/Courses/Course.tsx[22:8]
function ValueLabelComponent(props: any) {
	const { children, open, value } = props;

	return (
		<Tooltip
			enterTouchDelay={0}
			open={open}
			placement={'top'}
			title={value}
		>
			{children}
		</Tooltip>
	);
}

const format = (seconds: number) => {
	if (isNaN(seconds)) {
		return `00:00`;
	}

	const date = new Date(seconds * 1000);
	const hh = date.getUTCHours();
	const mm = date.getUTCMinutes();
	const ss = date.getUTCSeconds().toString().padStart(2, '0');

	if (hh) {
		return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`;
	}

	return `${mm}:${ss}`;
};

let count = 0;

// NOTE:
// ./src/modules/Private/Courses/Course.tsx[22:8]
function VideoPlayer({ url }: any) {
	const classes = useStyles();
	const [showControls, setShowControls] = useState(false);
	// Const [count, setCount] = useState(0);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [timeDisplayFormat, setTimeDisplayFormat] = React.useState('normal');
	const [bookmarks, setBookmarks] = useState([]);
	const [state, setState] = useState({
		controls: false,
		duration: 0,
		light: false,
		loop: false,

		muted: true,
		pip: false,
		playbackRate: 1.0,
		played: 0,
		playing: true,
		seeking: false,
		volume: 1,
	});

	const playerRef = useRef(null);
	const playerContainerRef = useRef(null);
	const controlsRef = useRef(null);
	const canvasRef = useRef(null);
	const {
		controls,
		light,
		loop,

		muted,
		pip,
		playbackRate,
		played,
		playing,
		seeking,
		volume,
	} = state;

	const handlePlayPause = () => {
		setState({ ...state, playing: !state.playing });
	};

	const handleRewind = () => {
		playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
	};

	const handleFastForward = () => {
		playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
	};

	const handleProgress = (changeState) => {
		if (count > 3) {
			controlsRef.current.style.visibility = 'hidden';
			count = 0;
		}

		if (controlsRef.current.style.visibility == 'visible') {
			count += 1;
		}

		if (!state.seeking) {
			setState({ ...state, ...changeState });
		}
	};

	const handleSeekChange = (e, newValue) => {
		console.log({ newValue });
		setState({ ...state, played: parseFloat(newValue / 100) });
	};

	const handleSeekMouseDown = (e) => {
		setState({ ...state, seeking: true });
	};

	const handleSeekMouseUp = (e, newValue) => {
		console.log({ value: e.target });
		setState({ ...state, seeking: false });
		// Console.log(sliderRef.current.value)
		playerRef.current.seekTo(newValue / 100, 'fraction');
	};

	const handleDuration = (duration) => {
		setState({ ...state, duration });
	};

	const handleVolumeSeekDown = (e, newValue) => {
		setState({
			...state,
			seeking: false,
			volume: parseFloat(newValue / 100),
		});
	};

	const handleVolumeChange = (e, newValue) => {
		// Console.log(newValue);
		setState({
			...state,
			muted: newValue === 0,
			volume: parseFloat(newValue / 100),
		});
	};

	const toggleFullScreen = () => {
		screenful.toggle(playerContainerRef.current);
	};

	const handleMouseMove = () => {
		console.log('mousemove');
		controlsRef.current.style.visibility = 'visible';
		count = 0;
	};

	const hanldeMouseLeave = () => {
		controlsRef.current.style.visibility = 'hidden';
		count = 0;
	};

	const handleDisplayFormat = () => {
		setTimeDisplayFormat(
			timeDisplayFormat == 'normal' ? 'remaining' : 'normal',
		);
	};

	const handlePlaybackRate = (rate) => {
		setState({ ...state, playbackRate: rate });
	};

	const hanldeMute = () => {
		setState({ ...state, muted: !state.muted });
	};

	const addBookmark = () => {
		const canvas = canvasRef.current;
		canvas.width = 160;
		canvas.height = 90;
		const ctx = canvas.getContext('2d');

		ctx.drawImage(
			playerRef.current.getInternalPlayer(),
			0,
			0,
			canvas.width,
			canvas.height,
		);

		const dataUri = canvas.toDataURL();
		canvas.width = 0;
		canvas.height = 0;
		const bookmarksCopy = [...bookmarks];
		bookmarksCopy.push({
			display: format(playerRef.current.getCurrentTime()),
			image: dataUri,
			time: playerRef.current.getCurrentTime(),
		});

		setBookmarks(bookmarksCopy);
	};

	const currentTime =
		playerRef && playerRef.current
			? playerRef.current.getCurrentTime()
			: '00:00';

	const duration =
		playerRef && playerRef.current
			? playerRef.current.getDuration()
			: '00:00';

	const elapsedTime =
		timeDisplayFormat == 'normal'
			? format(currentTime)
			: `-${format(duration - currentTime)}`;

	const totalDuration = format(duration);

	return (
		<>
			<AppBar position={'fixed'}>
				<Toolbar>
					<Typography>React Video Player</Typography>
				</Toolbar>
			</AppBar>

			<Toolbar />

			<Container maxWidth={'md'}>
				<div
					className={classes.playerWrapper}
					onMouseLeave={hanldeMouseLeave}
					onMouseMove={handleMouseMove}
					ref={playerContainerRef}
				>
					<ReactPlayer
						config={{
							file: {
								attributes: {
									crossorigin: 'anonymous',
								},
							},
						}}
						controls={false}
						height={'100%'}
						light={light}
						loop={loop}
						muted={muted}
						onProgress={handleProgress}
						pip={pip}
						playbackRate={playbackRate}
						playing={playing}
						ref={playerRef}
						url={url}
						volume={volume}
						width={'100%'}
					/>

					<Controls
						elapsedTime={elapsedTime}
						muted={muted}
						onBookmark={addBookmark}
						onChangeDispayFormat={handleDisplayFormat}
						onDuration={handleDuration}
						onFastForward={handleFastForward}
						onMute={hanldeMute}
						onPlayPause={handlePlayPause}
						onPlaybackRateChange={handlePlaybackRate}
						onRewind={handleRewind}
						onSeek={handleSeekChange}
						onSeekMouseDown={handleSeekMouseDown}
						onSeekMouseUp={handleSeekMouseUp}
						onToggleFullScreen={toggleFullScreen}
						onVolumeChange={handleVolumeChange}
						onVolumeSeekDown={handleVolumeSeekDown}
						playbackRate={playbackRate}
						played={played}
						playing={playing}
						ref={controlsRef}
						totalDuration={totalDuration}
						volume={volume}
					/>
				</div>

				<Grid container spacing={3} style={{ marginTop: 20 }}>
					{bookmarks.map((bookmark, index) => (
						<Grid item key={index}>
							<Paper
								elevation={3}
								onClick={() => {
									playerRef.current.seekTo(bookmark.time);
									controlsRef.current.style.visibility =
										'visible';

									setTimeout(() => {
										controlsRef.current.style.visibility =
											'hidden';
									}, 1000);
								}}
							>
								<img
									crossOrigin={'anonymous'}
									src={bookmark.image}
								/>

								<Typography align={'center'} variant={'body2'}>
									bookmark at {bookmark.display}
								</Typography>
							</Paper>
						</Grid>
					))}
				</Grid>

				<canvas ref={canvasRef} />
			</Container>
		</>
	);
}

export default VideoPlayer;
